import { ANYWHERE_PLACE_ID } from 'constants/search'
import { createNaturalLanguageItem } from 'lib/search/searchUtils'

export function isExperienceNaturalLanguageItem(item?: App.SearchItem): item is App.SearchItemV3 {
  return item?.searchType === 'searchItemV3' && item.display.searchType === 'naturalLanguage'
}

export function createExperienceNaturalLanguageItem(query: string, typeaheadId: string): App.SearchItemV3 {
  return createNaturalLanguageItem(query, { typeaheadId, isComplete: false })
}

export function getExperienceNaturalLanguageItemFromUrl(params: URLSearchParams): App.SearchItemV3 | undefined {
  const query = params.get('query')?.trim()
  const typeaheadId = params.get('typeaheadId')
  if (!query || !typeaheadId) return undefined
  const item = createExperienceNaturalLanguageItem(query, typeaheadId)
  return {
    ...item,
    searchItem: {
      typeaheadId,
      extracting: params.get('extracting') === 'true',
      extractedData: {
        query,
        searchType: 'destination',
        placeIds: params.get('destinationId')?.split(',').filter(Boolean) ?? [ANYWHERE_PLACE_ID],
        semanticSearchQuery: params.get('semanticSearchQuery') ?? undefined,
      },
    },
  }
}

export function getCompletedExperienceQuery(
  data: App.TypeaheadStreamingData | undefined,
  query: string,
): App.SearchItemV3 | undefined {
  const final = data?.finalSearchItem
  if (
    data?.isComplete && !data.streamingError &&
    data.completedInput === query && final?.input === query &&
    !final.data?.searchItem.extracting
  ) {
    return final.data
  }
  return undefined
}

export function getExperienceNaturalLanguageParams(item: App.SearchItemV3) {
  const { extractedData, typeaheadId, extracting } = item.searchItem
  const base = { query: item.value, typeaheadId }
  if (extracting) return { ...base, extracting: 'true' }

  // Experience location search currently accepts place IDs. Do not turn an
  // unsupported coordinate result or an invalid remainder into an Anywhere search.
  if (!('placeIds' in extractedData) || (extractedData.semanticSearchQuery?.length ?? 0) > 500) {
    return undefined
  }
  return {
    ...base,
    destinationId: extractedData.placeIds?.length ? extractedData.placeIds.join(',') : ANYWHERE_PLACE_ID,
    semanticSearchQuery: extractedData.semanticSearchQuery?.trim() || undefined,
  }
}
